export default (() => {
  const SELECTOR = '.js-number-incr-effect'
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

  // 解析字串 → 數字（允許負號與小數）
  const parseNum = (str) => parseFloat(String(str).replace(/[^0-9.+-]/g, ''))

  const animate = (el) => {
    if (el.dataset.animated === '1') return

    // 目標值：優先 data-target，否則用元素現有文字
    const to =
      el.dataset.target != null
        ? parseNum(el.dataset.target)
        : parseNum(el.textContent)
    if (Number.isNaN(to)) return

    const prefersReduced = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
    const from = el.dataset.from != null ? parseNum(el.dataset.from) : 0
    const decimals = Number(el.dataset.decimals) || 0
    const autoDuration = Math.min(
      2000,
      400 + Math.log10(Math.max(10, Math.abs(to - from))) * 600
    )
    const duration = Number(el.dataset.duration) || autoDuration
    const fmt = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })

    // 降低動態時直接顯示最終值
    if (prefersReduced || duration <= 0) {
      el.textContent = fmt.format(to)
      el.dataset.animated = '1'
      return
    }

    const startTime = performance.now()
    el.textContent = fmt.format(from)

    const tick = (now) => {
      const p = Math.min((now - startTime) / duration, 1)
      const v = from + (to - from) * easeOutCubic(p)
      const rounded = +v.toFixed(decimals)
      el.textContent = fmt.format(decimals ? rounded : Math.round(rounded))
      if (p < 1) {
        requestAnimationFrame(tick)
      } else {
        el.textContent = fmt.format(to)
        el.dataset.animated = '1'
      }
    }

    requestAnimationFrame(tick)
  }

  document.addEventListener('DOMContentLoaded', () => {
    // 滾到可視範圍才啟動；每個元素只跑一次
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(entry.target)
            obs.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.4 }
    )

    document.querySelectorAll(SELECTOR).forEach((el) => {
      io.observe(el)
    })

    // 若 data-target 更新，重新啟動動畫（適合購物車數量變化）
    const mo = new MutationObserver((muts) => {
      muts.forEach((m) => {
        if (m.type === 'attributes' && m.attributeName === 'data-target') {
          const el = m.target
          // 從目前顯示值 → 新目標值
          el.dataset.from = parseNum(el.textContent) || 0
          el.dataset.animated = '' // 允許再次動畫
          animate(el)
        }
      })
    })

    document.querySelectorAll(SELECTOR).forEach((el) => {
      mo.observe(el, { attributes: true, attributeFilter: ['data-target'] })
    })
  })
})()
